import { fetchFlask } from '../../utils/fetchFlask';

export const fetchSituacaoInadimplentes = async () => {
    const response = await fetchFlask('getSituacaoInadimplentes');
    return response.inadimplentes;
};

export const buildSituacaoRows = (inadimplentes) => inadimplentes.map((inadimplente) => ({
    id: inadimplente.cc_id,
    cc: inadimplente.cc,
    faturas: inadimplente.faturas,
    valorDevido: inadimplente.valor_devido,
    matricula: inadimplente.matricula,
    cliente: inadimplente.cliente,
    contatoNome: inadimplente.contato_nome,
    telefone: inadimplente.telefone
}));

export const buildSituacaoSummary = (inadimplentes) => inadimplentes.reduce((summary, inadimplente) => ({
    unidades: summary.unidades + 1,
    faturas: summary.faturas + inadimplente.faturas,
    valorDevido: summary.valorDevido + inadimplente.valor_devido
}), { unidades: 0, faturas: 0, valorDevido: 0 });
